var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    clipPath: "url(#clip0_3035_8074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2187 0.719364C18.2884 0.649519 18.3711 0.594105 18.4623 0.556295C18.5534 0.518486 18.6511 0.499023 18.7497 0.499023C18.8484 0.499023 18.946 0.518486 19.0372 0.556295C19.1283 0.594105 19.211 0.649519 19.2807 0.719364L23.7807 5.21936C23.8506 5.28903 23.906 5.3718 23.9438 5.46291C23.9816 5.55403 24.001 5.65171 24.001 5.75036C24.001 5.84902 23.9816 5.9467 23.9438 6.03781C23.906 6.12893 23.8506 6.2117 23.7807 6.28136L8.78071 21.2814C8.70873 21.3528 8.623 21.409 8.52871 21.4464L1.02871 24.4464C0.892413 24.5009 0.743103 24.5143 0.599288 24.4848C0.455474 24.4553 0.32348 24.3842 0.21967 24.2804C0.11586 24.1766 0.0448002 24.0446 0.015299 23.9008C-0.0142021 23.757 -0.000846891 23.6077 0.0537091 23.4714L3.05371 15.9714C3.0911 15.8771 3.14723 15.7913 3.21871 15.7194L18.2187 0.719364ZM16.8102 4.25036L20.2497 7.68986L22.1892 5.75036L18.7497 2.31086L16.8102 4.25036ZM19.1892 8.75036L15.7497 5.31086L5.99971 15.0609V15.5004H6.74971C6.94862 15.5004 7.13939 15.5794 7.28004 15.72C7.42069 15.8607 7.49971 16.0515 7.49971 16.2504V17.0004H8.24971C8.44862 17.0004 8.63939 17.0794 8.78004 17.22C8.92069 17.3607 8.99971 17.5515 8.99971 17.7504V18.5004H9.43921L19.1892 8.75036ZM4.54771 16.5129L4.38871 16.6719L2.09671 22.4034L7.82821 20.1114L7.98721 19.9524C7.84414 19.8989 7.7208 19.803 7.63368 19.6776C7.54656 19.5522 7.49982 19.4031 7.49971 19.2504V18.5004H6.74971C6.5508 18.5004 6.36003 18.4213 6.21938 18.2807C6.07873 18.14 5.99971 17.9493 5.99971 17.7504V17.0004H5.24971C5.09698 17.0002 4.94792 16.9535 4.82247 16.8664C4.69703 16.7793 4.60116 16.6559 4.54771 16.5129Z",
    fill: "#1C2026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3035_8074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.2290b464a3da7ea8430f1268d28dc507.svg";
export { ForwardRef as ReactComponent };